import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { callAPI } from "../feature/APISlice";
import { openForm } from "../feature/formSlice";
import AdminNavbar from "./AdminNavbar";
import CoreInitiativeForm from "../Form/CoreInitiativeForm";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/core-initiatives`;

export default function CoreInitiativeList() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.api);

  useEffect(() => {
    dispatch(callAPI({ method: "get", url: BASE_URL }));
  }, [dispatch]);
  const formatDate = (date) =>
    date ? new Date(date).toLocaleString() : "N/A";
  return (
    <div>
      <AdminNavbar />

      <div className="customcontainer">
        <button className="admin-btn outline" onClick={() => dispatch(openForm(null))}>
          + Add Core Initiative
        </button>

        {loading && <p>Loading...</p>}
        {error && <p className="error-text">{error}</p>}

        <div className="admin-card-grid">
          {items.map((i) => (
            <div className="admin-card" key={i.id}>
              <h4>{i?.title}</h4>

              <p>Status: {i?.is_active ? " Active" : "❌ Inactive"}</p>

              <p>Created By: {i.createdByName}</p>
              <p>Created Time: {formatDate(i?.createdTime)}</p>

              <p>Updated By: {i?.lastModifiedByName}</p>
              <p>Updated Time: {formatDate(i?.updatedTime)}</p>
              <div className="admin-card-actions">
                <button onClick={() => dispatch(openForm(i.id))}>✏️</button>
                <button
                  onClick={() =>
                    window.confirm("Delete?") &&
                    dispatch(callAPI({
                      method: "delete",
                      url: `${BASE_URL}/${i.id}`,
                      data: { id: i.id },
                    }))
                  }
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <CoreInitiativeForm />
    </div>
  );
}
